module.exports = __webpack_public_path__ + "static/media/ft-platform.c373812e.svg";